<div class="preload-wrapper popup-loader">
  <div class="tf-slideshow slider-effect-fade position-relative">
  <div dir="ltr" class="swiper tf-sw-slideshow" data-preview="1" data-tablet="1" data-mobile="1"
      data-centered="false" data-space="0" data-loop="true" data-auto-play="false" data-delay="0"
      data-speed="1000">
      <div class="swiper-wrapper">
          <div class="swiper-slide">
              <div class="wrap-slider">
                  <img src="assets/images/slider/fashion-slideshow-01.jpg" alt="fashion-slideshow">
                  <div class="box-content">
                      <div class="container">
                          <h1 class="fade-item fade-item-1">Glamorous<br>Glam</h1>
                          <p class="fade-item fade-item-2">From casual to formal, we've got you covered</p>
                          <a href="shop-default.html"
                              class="fade-item fade-item-3 tf-btn btn-fill animate-hover-btn btn-xl radius-3"><span>Shop
                                  collection</span><i class="icon icon-arrow-right"></i></a>
                      </div>
                  </div>
              </div>
          </div>
          <div class="swiper-slide">
              <div class="wrap-slider">
                  <img src="assets/images/slider/fashion-slideshow-02.jpg" alt="fashion-slideshow">
                  <div class="box-content">
                      <div class="container">
                          <h1 class="fade-item fade-item-1">Simple <br class="md-hidden">Style</h1>
                          <p class="fade-item fade-item-2">From casual to formal, we've got you covered</p>
                          <a href="shop-default.html"
                              class="fade-item fade-item-3 tf-btn btn-fill animate-hover-btn btn-xl radius-3"><span>Shop
                                  collection</span><i class="icon icon-arrow-right"></i></a>
                      </div>
                  </div>
              </div>
          </div>
          <div class="swiper-slide">
              <div class="wrap-slider">
                  <img src="assets/images/slider/fashion-slideshow-03.jpg" alt="fashion-slideshow">
                  <div class="box-content">
                      <div class="container">
                          <h1 class="fade-item fade-item-1">Glamorous<br>Glam</h1>
                          <p class="fade-item fade-item-2">From casual to formal, we've got you covered</p>
                          <a href="shop-default.html"
                              class="fade-item fade-item-3 tf-btn btn-fill animate-hover-btn btn-xl radius-3"><span>Shop
                                  collection</span><i class="icon icon-arrow-right"></i></a>
                      </div>
                  </div>

              </div>
          </div>
      </div>
  </div>
  <div class="wrap-pagination">
      <div class="container">
          <div class="sw-dots sw-pagination-slider justify-content-center"></div>
      </div>
  </div>
</div>
<!-- /Slider -->
<!-- Marquee -->
<div class="tf-marquee bg_yellow-2">
  <div class="wrap-marquee">
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
      <div class="marquee-item">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" class="" width="15" height="20" viewBox="0 0 15 20">
                  <path d="M14.5833 8H8.61742L9.94318 0L0 12H5.96591L4.64015 20L14.5833 8"></path>
              </svg>
          </div>
          <p class="text">Spring Clearance Event: Save Up to 70%</p>
      </div>
  </div>

</div>
<section class="flat-spacing-4 flat-categorie">
  <div class="container-full">
      <div class="flat-title-v2">
          <div class="box-sw-navigation">
              <div class="nav-sw nav-next-slider nav-next-collection"><span
                      class="icon icon-arrow-left"></span></div>
              <div class="nav-sw nav-prev-slider nav-prev-collection"><span
                      class="icon icon-arrow-right"></span></div>
          </div>
          <span class="text-3 fw-7 text-uppercase title wow fadeInUp" data-wow-delay="0s">SHOP BY
              CATEGORIES</span>
      </div>
      <div class="row">
          <div class="col-12">
              <div dir="ltr" class="swiper tf-sw-collection" data-preview="3" data-tablet="2" data-mobile="2"
                  data-space-lg="30" data-space-md="30" data-space="15" data-loop="false"
                  data-auto-play="false">
                  <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let cat of Categorie" lazy="true">
                      <div class="collection-item style-left hover-img">
                        <div class="collection-inner">
                          <a (click)="navigateToCategory(cat)" class="collection-image img-style" style="cursor: pointer;">
                            <img class="lazyload"
                                 [attr.data-src]="cat.image"
                                 [src]="cat.image"
                                 [alt]="cat.libelle">
                          </a>
                          <div class="collection-content">
                            <a (click)="navigateToCategory(cat)" class="tf-btn collection-title hover-icon fs-15" style="cursor: pointer;">
                              <span>{{ cat.libelle }}</span>
                              <i class="icon icon-arrow1-top-left"></i>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

              </div>
          </div>

      </div>

  </div>
</section>
<!-- /Categories -->
<section class="flat-spacing-5 pt_0 flat-seller">
  <div class="container">
      <div class="flat-title">
          <span class="title wow fadeInUp" data-wow-delay="0s">Promotions</span>
          <p class="sub-title wow fadeInUp" data-wow-delay="0s">Shop the Latest Styles: Stay ahead of the
              curve with our newest arrivals</p>
      </div>


      <div class="wrap-carousel promo-carousel">

        <!-- Flèche gauche -->
        <div class="nav-sw nav-prev-slider nav-prev-testimonial lg" (click)="changePage('prev', 'promo')"  [ngClass]="{ 'disabled': currentPagePromo === 0 }">
          <span class="icon icon-arrow-left" style="cursor: pointer;"></span>
        </div>


        <!-- Zone scrollable -->
        <div class="grid-scrollable" #scrollContainer>

          <div class="grid-layout wow fadeInUp" data-grid="grid-4">


            <!-- card product 1 -->

              <div class="card-product fl-item" *ngFor="let article of promoArticles">
                <div class="card-product-wrapper">
                  <a (click)="goToProduct(article.id, article.libelle)" class="product-img" style="cursor: pointer;">
                    <img class="lazyload img-product"
                         [attr.data-src]="article.images[0]?.data"
                         [src]="article.images[0]?.data"
                         alt="image-product">
                    <img class="lazyload img-hover"
                         [attr.data-src]="article.images[1]?.data || article.images[0]?.data"
                         [src]="article.images[1]?.data || article.images[0]?.data"
                         alt="image-product">
                  </a>

                  <div class="list-product-btn">
                    <a  data-bs-toggle="modal"
                       class="box-icon bg_white quick-add tf-btn-loading" (click)="addToCart($event,article, quantity)">
                      <span class="icon icon-bag"></span>
                      <span class="tooltip">Commander</span>
                    </a>
                    <a href="javascript:void(0);" (click)="addToWishlist(article)" class="box-icon bg_white wishlist btn-icon-action" >
                      <span class="icon icon-heart"></span>
                      <span class="tooltip">Ajouter au Favoris</span>
                      <span class="icon icon-delete"></span>
                    </a>

                    <a  (click)="goToProduct(article.id, article.libelle)" data-bs-toggle="modal"
                       class="box-icon bg_white quickview tf-btn-loading">
                      <span class="icon icon-view"></span>
                      <span class="tooltip">Voir Détails</span>
                    </a>
                  </div>
                  <div class="on-sale-wrap">
                    <div class="on-sale-item" *ngIf="article.promo !== 0" > -{{ ((1 - article.prix_final / article.prix_ttc) * 100) | number:'1.0-0' }}%</div>
                </div>
                  <!-- <div class="size-list">
                    <span>S</span>
                    <span>M</span>
                    <span>L</span>
                    <span>XL</span>
                  </div> -->
                </div>

                <div class="card-product-info">
                  <a (click)="goToProduct(article.id, article.libelle)" class="title link"   style="cursor: pointer; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; min-height: 2.4em; line-height: 1.2em;">
                    {{ article.libelle }}
                  </a>
                  <div class="product-price">
                    <ng-container *ngIf="article.promo !== 0; else noPromo">
                      <span class="price" style="color:red;">{{ article.prix_final | number:'1.3-3'}} DT</span>
                      <del class="ms-2">{{ article.prix_ttc | number:'1.3-3' }} DT</del>
                    </ng-container>
                    <ng-template #noPromo>
                      <span class="price" style="color:red;">{{ article.prix_ttc | number:'1.3-3' }} DT</span>
                    </ng-template>
                  </div>

                  <li *ngFor="let variant of article.details_variant"
                  class="list-color-item color-swatch"
                  [ngClass]="{'selected': selectedTeinte === variant.libelle}"
                  (click)="selectTeinte(variant)">
                <span class="tooltip">{{ variant.libelle }}</span>
                <span class="swatch-value" [style.background-color]="variant.icon_color"></span>
              </li>

                </div>
              </div>


        </div>
        </div>

        <!-- Flèche droite -->
        <div class="nav-sw nav-next-slider nav-next-testimonial lg"
       (click)="changePage('next', 'promo')"
       [ngClass]="{ 'disabled': (currentPagePromo + 1) * itemsPerPage >= ListArticlesPromo.length }">
    <span class="icon icon-arrow-right" style="cursor: pointer;"></span>
  </div>

      </div>




  </div>
</section>
<!-- Seller -->
<section class="flat-spacing-5 pt_0 flat-seller">
  <div class="container">
      <div class="flat-title">
          <span class="title wow fadeInUp" data-wow-delay="0s">Nouveautés</span>
          <p class="sub-title wow fadeInUp" data-wow-delay="0s">Shop the Latest Styles: Stay ahead of the
              curve with our newest arrivals</p>
      </div>


      <div class="wrap-carousel promo-carousel">

        <!-- Flèche gauche -->
        <div class="nav-sw nav-prev-slider nav-prev-testimonial lg" (click)="changePage('prev', 'nouveautes')"  [ngClass]="{ 'disabled': currentPageNouveautes === 0 }">
          <span class="icon icon-arrow-left" style="cursor: pointer;"></span>
        </div>


        <!-- Zone scrollable -->
        <div class="grid-scrollable" #scrollContainer>

          <div class="grid-layout wow fadeInUp" data-grid="grid-4">


            <!-- card product 1 -->

              <div class="card-product fl-item" *ngFor="let article of nouveautesArticles">
                <div class="card-product-wrapper">
                  <a (click)="goToProduct(article.id, article.libelle)" class="product-img" style="cursor: pointer;">
                    <img class="lazyload img-product"
                         [attr.data-src]="article.images[0]?.data"
                         [src]="article.images[0]?.data"
                         alt="image-product">
                    <img class="lazyload img-hover"
                         [attr.data-src]="article.images[1]?.data || article.images[0]?.data"
                         [src]="article.images[1]?.data || article.images[0]?.data"
                         alt="image-product">
                  </a>

                  <div class="list-product-btn">
                    <a  data-bs-toggle="modal"
                       class="box-icon bg_white quick-add tf-btn-loading" (click)="addToCart($event,article, quantity)">
                      <span class="icon icon-bag"></span>
                      <span class="tooltip">Commander</span>
                    </a>
                    <a href="javascript:void(0);" (click)="addToWishlist(article)" class="box-icon bg_white wishlist btn-icon-action" >
                      <span class="icon icon-heart"></span>
                      <span class="tooltip">Ajouter au Favoris</span>
                      <span class="icon icon-delete"></span>
                    </a>

                    <a  (click)="goToProduct(article.id, article.libelle)" data-bs-toggle="modal"
                       class="box-icon bg_white quickview tf-btn-loading">
                      <span class="icon icon-view"></span>
                      <span class="tooltip">Voir Détails</span>
                    </a>
                  </div>
                  <div class="on-sale-wrap">
                    <div class="on-sale-item" *ngIf="article.promo !== 0" > -{{ ((1 - article.prix_final / article.prix_ttc) * 100) | number:'1.0-0' }}%</div>
                </div>
                  <!-- <div class="size-list">
                    <span>S</span>
                    <span>M</span>
                    <span>L</span>
                    <span>XL</span>
                  </div> -->
                </div>

                <div class="card-product-info">
                  <a (click)="goToProduct(article.id, article.libelle)" class="title link"   style="cursor: pointer; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; min-height: 2.4em; line-height: 1.2em;">
                    {{ article.libelle }}
                  </a>
                  <div class="product-price">
                    <ng-container *ngIf="article.promo !== 0; else noPromo">
                      <span class="price" style="color:red;">{{ article.prix_final | number:'1.3-3'}} DT</span>
                      <del class="ms-2">{{ article.prix_ttc | number:'1.3-3' }} DT</del>
                    </ng-container>
                    <ng-template #noPromo>
                      <span class="price" style="color:red;">{{ article.prix_ttc | number:'1.3-3' }} DT</span>
                    </ng-template>
                  </div>

                  <ul class="list-color-product" *ngIf="article.details_variant && article.details_variant.length > 0">
                    <li *ngFor="let variant of article.details_variant" class="list-color-item color-swatch">
                      <span class="tooltip">{{ variant.libelle }}</span>
                      <span class="swatch-value" [style.background-color]="variant.icon_color"></span>
                    </li>
                  </ul>

                </div>
              </div>


        </div>
        </div>

        <!-- Flèche droite -->
        <div class="nav-sw nav-next-slider nav-next-testimonial lg"
       (click)="changePage('next', 'nouveautes')"
       [ngClass]="{ 'disabled': (currentPageNouveautes + 1) * itemsPerPage >= ListArticles.length }">
    <span class="icon icon-arrow-right" style="cursor: pointer;"></span>
  </div>

      </div>

  </div>
</section>
<!-- /Seller -->
<!-- Lookbook -->
<section class="flat-spacing-6">
  <div class="flat-title wow fadeInUp" data-wow-delay="0s">
      <span class="title">Shop the look</span>
      <p class="sub-title">Inspire and let yourself be inspired, from one unique fashion to another.</p>
  </div>
  <div dir="ltr" class="swiper tf-sw-lookbook" data-preview="2" data-tablet="2" data-mobile="1"
      data-space-lg="0" data-space-md="0">
      <div class="swiper-wrapper">
          <div class="swiper-slide" lazy="true">
              <div class="wrap-lookbook lookbook-1">
                  <div class="image">
                      <img class="lazyload" data-src="assets/images/shop/file/lookbook-3.jpg"
                          src="assets/images/shop/file/lookbook-3.jpg" alt="image-lookbook">
                  </div>
                  <div class="lookbook-item item-1">
                      <div class="inner">
                          <div class="btn-group dropdown dropup dropdown-center">
                              <button class="tf-pin-btn" data-bs-toggle="dropdown" aria-expanded="false">
                                  <span></span>
                              </button>
                              <ul class="dropdown-menu p-0 border-0">
                                  <li>
                                      <div class="lookbook-product">
                                          <a href="product-detail.html" class="image">
                                              <img class="lazyload" data-src="assets/images/shop/products/img-p2.png"
                                                  src="assets/images/shop/products/img-p2.png" alt="lookbook-item">
                                          </a>
                                          <div class="content-wrap">
                                              <div class="product-title">
                                                  <a href="#">Jersey thong body</a>
                                              </div>
                                              <div class="price">$112.00</div>
                                          </div>
                                          <a href="#quick_view" data-bs-toggle="modal" class=""><i
                                                  class="icon-view"></i></a>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
                  <div class="lookbook-item item-2">
                      <div class="inner">
                          <div class="btn-group dropdown dropup dropdown-center">
                              <button class="tf-pin-btn" data-bs-toggle="dropdown" aria-expanded="false">
                                  <span></span>
                              </button>
                              <ul class="dropdown-menu p-0 border-0">
                                  <li>
                                      <div class="lookbook-product">
                                          <a href="product-detail.html" class="image">
                                              <img class="lazyload" data-src="assets/images/shop/products/img-p4.png"
                                                  src="assets/images/shop/products/img-p4.png" alt="">
                                          </a>
                                          <div class="content-wrap">
                                              <div class="product-title">
                                                  <a href="#">Ribbed modal T-shirt</a>
                                              </div>
                                              <div class="price">$20.00</div>
                                          </div>
                                          <a href="#quick_view" data-bs-toggle="modal" class=""><i
                                                  class="icon-view"></i></a>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="swiper-slide" lazy="true">
              <div class="wrap-lookbook lookbook-2">
                  <div class="image">
                      <img class="lazyload" data-src="assets/images/shop/file/lookbook-4.jpg"
                          src="assets/images/shop/file/lookbook-4.jpg" alt="image-lookbook">
                  </div>
                  <div class="lookbook-item item-1">
                      <div class="inner">
                          <div class="btn-group dropdown dropup dropdown-center">
                              <button class="tf-pin-btn" data-bs-toggle="dropdown" aria-expanded="false">
                                  <span></span>
                              </button>
                              <ul class="dropdown-menu p-0 border-0">
                                  <li>
                                      <div class="lookbook-product">
                                          <a href="product-detail.html" class="image">
                                              <img class="lazyload" data-src="assets/images/shop/products/img-p5.png"
                                                  src="assets/images/shop/products/img-p5.png" alt="">
                                          </a>
                                          <div class="content-wrap">
                                              <div class="product-title">
                                                  <a href="#">Ribbed Tank Top</a>
                                              </div>
                                              <div class="price">$20.00</div>
                                          </div>
                                          <a href="#quick_view" data-bs-toggle="modal" class=""><i
                                                  class="icon-view"></i></a>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="wrap-pagination">
          <div class="container-full">
              <div class="sw-dots sw-pagination-lookbook justify-content-center"></div>
          </div>
      </div>
  </div>
</section>
<!-- /brand -->

<section class="flat-spacing-7">
  <div class="container">
    <div class="flat-title wow fadeInUp" data-wow-delay="0s">
      <span class="title">Nos Marques</span>
      <p class="sub-title">Défilement automatique des marques</p>
    </div>

    <div class="marques-carousel">
      <div class="marques-track" id="marques-track">
        <div class="marque-item" *ngFor="let marque of Marques">
          <img
            class="marque-img"
            [src]="marque.image"
            [alt]="marque.libelle"
            style="cursor: pointer;"
            (click)="navigateToBrand(marque)"
          />
        </div>
        <!-- Duplique une 2e fois pour effet boucle infinie -->
        <div class="marque-item" *ngFor="let marque of Marques">
          <img
            class="marque-img"
            [src]="marque.image"
            [alt]="marque.libelle"
            style="cursor: pointer;"
            (click)="navigateToBrand(marque)"
          />
        </div>
      </div>
    </div>
  </div>



</section>
<!-- /Lookbook -->
<!-- Testimonial -->
<section class="flat-spacing-5 pt_0 flat-testimonial">
  <div class="container">
      <div class="flat-title wow fadeInUp" data-wow-delay="0s">
          <span class="title">Happy Clients</span>
          <p class="sub-title">Hear what they say about us</p>
      </div>
      <div class="wrap-carousel">
          <div dir="ltr" class="swiper tf-sw-testimonial" data-preview="3" data-tablet="2" data-mobile="1"
              data-space-lg="30" data-space-md="15">
              <div class="swiper-wrapper">
                  <div class="swiper-slide">
                      <div class="testimonial-item style-column wow fadeInUp" data-wow-delay="0s">
                          <div class="rating">
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                          </div>
                          <div class="heading">Best Online Fashion Site</div>
                          <div class="text">
                              “ I always find something stylish and affordable on this web fashion site ”
                          </div>
                          <div class="author">
                              <div class="name">Robert smith</div>
                              <div class="metas">Customer from USA</div>
                          </div>
                          <div class="product">
                              <div class="image">
                                  <a href="product-detail.html">
                                      <img class="lazyload" data-src="assets/images/shop/products/img-p2.png"
                                          src="assets/images/shop/products/img-p2.png" alt="">
                                  </a>
                              </div>
                              <div class="content-wrap">
                                  <div class="product-title">
                                      <a href="product-detail.html">Jersey thong body</a>
                                  </div>
                                  <div class="price">$105.95</div>
                              </div>
                              <a href="product-detail.html" class=""><i class="icon-arrow1-top-left"></i></a>
                          </div>
                      </div>
                  </div>
                  <div class="swiper-slide">
                      <div class="testimonial-item style-column wow fadeInUp" data-wow-delay=".1s">
                          <div class="rating">
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                          </div>
                          <div class="heading">Great Selection and Quality</div>
                          <div class="text">
                              "I love the variety of styles and the high-quality clothing on this web fashion
                              site."
                          </div>
                          <div class="author">
                              <div class="name">Allen Lyn</div>
                              <div class="metas">Customer from France</div>
                          </div>
                          <div class="product">
                              <div class="image">
                                  <a href="product-detail.html">
                                      <img class="lazyload" data-src="assets/images/shop/products/img-p3.png"
                                          src="assets/images/shop/products/img-p3.png" alt="">
                                  </a>
                              </div>
                              <div class="content-wrap">
                                  <div class="product-title">
                                      <a href="product-detail.html">Cotton jersey top</a>
                                  </div>
                                  <div class="price">$7.95</div>
                              </div>
                              <a href="product-detail.html" class=""><i class="icon-arrow1-top-left"></i></a>
                          </div>
                      </div>
                  </div>
                  <div class="swiper-slide">
                      <div class="testimonial-item style-column wow fadeInUp" data-wow-delay=".2s">
                          <div class="rating">
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                          </div>
                          <div class="heading">Best Customer Service</div>
                          <div class="text">
                              "I finally found a web fashion site with stylish and flattering options in my
                              size."
                          </div>
                          <div class="author">
                              <div class="name">Peter Rope</div>
                              <div class="metas">Customer from USA</div>
                          </div>
                          <div class="product">
                              <div class="image">
                                  <a href="product-detail.html">
                                      <img class="lazyload" data-src="assets/images/shop/products/img-p4.png"
                                          src="assets/images/shop/products/img-p4.png" alt="">
                                  </a>
                              </div>
                              <div class="content-wrap">
                                  <div class="product-title">
                                      <a href="product-detail.html">Ribbed modal T-shirt</a>
                                  </div>
                                  <div class="price">From $18.95</div>
                              </div>
                              <a href="product-detail.html" class=""><i class="icon-arrow1-top-left"></i></a>
                          </div>
                      </div>
                  </div>
                  <div class="swiper-slide">
                      <div class="testimonial-item style-column wow fadeInUp" data-wow-delay=".3s">
                          <div class="rating">
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                              <i class="icon-star"></i>
                          </div>
                          <div class="heading">Great Selection and Quality</div>
                          <div class="text">
                              "I love the variety of styles and the high-quality clothing on this web fashion
                              site."
                          </div>
                          <div class="author">
                              <div class="name">Hellen Ase</div>
                              <div class="metas">Customer from Japan</div>
                          </div>
                          <div class="product">
                              <div class="image">
                                  <a href="product-detail.html">
                                      <img class="lazyload" data-src="assets/images/shop/products/img-p5.png"
                                          src="assets/images/shop/products/img-p5.png" alt="">
                                  </a>
                              </div>
                              <div class="content-wrap">
                                  <div class="product-title">
                                      <a href="product-detail.html">Customer from Japan</a>
                                  </div>
                                  <div class="price">$16.95</div>
                              </div>
                              <a href="product-detail.html" class=""><i class="icon-arrow1-top-left"></i></a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="nav-sw nav-next-slider nav-next-testimonial lg"><span
            class="icon icon-arrow-left"></span></div>
    <div class="nav-sw nav-prev-slider nav-prev-testimonial lg"><span
            class="icon icon-arrow-right"></span></div>
          <div class="sw-dots style-2 sw-pagination-testimonial justify-content-center"></div>
      </div>
  </div>
</section>


<!-- /Shop Gram -->
<!-- Icon box -->
<section class="flat-spacing-7 flat-iconbox wow fadeInUp" data-wow-delay="0s">
  <div class="container">
      <div class="wrap-carousel wrap-mobile">
          <div dir="ltr" class="swiper tf-sw-mobile" data-preview="1" data-space="15">
              <div class="swiper-wrapper wrap-iconbox">
                  <div class="swiper-slide">
                      <div class="tf-icon-box style-border-line text-center">
                          <div class="icon">
                              <i class="icon-shipping"></i>
                          </div>
                          <div class="content">
                              <div class="title">Free Shipping</div>
                              <p>Free shipping over order $120</p>
                          </div>
                      </div>
                  </div>
                  <div class="swiper-slide">
                      <div class="tf-icon-box style-border-line text-center">
                          <div class="icon">
                              <i class="icon-payment fs-22"></i>
                          </div>
                          <div class="content">
                              <div class="title">Flexible Payment</div>
                              <p>Pay with Multiple Credit Cards</p>
                          </div>
                      </div>
                  </div>
                  <div class="swiper-slide">
                      <div class="tf-icon-box style-border-line text-center">
                          <div class="icon">
                              <i class="icon-return fs-22"></i>
                          </div>
                          <div class="content">
                              <div class="title">14 Day Returns</div>
                              <p>Within 30 days for an exchange</p>
                          </div>
                      </div>
                  </div>
                  <div class="swiper-slide">
                      <div class="tf-icon-box style-border-line text-center">
                          <div class="icon">
                              <i class="icon-suport"></i>
                          </div>
                          <div class="content">
                              <div class="title">Premium Support</div>
                              <p>Outstanding premium support</p>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="sw-dots style-2 sw-pagination-mb justify-content-center"></div>
      </div>
  </div>
</section>

</div>
